import environment from "../../../../scripts/environment";
import translate from "../../../../scripts/core/tools/translate";

export class CompanyCustomersPotentialAfterSalesFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }
    getData() {
        const CommercialRelationshipTypes = environment.get('CONFIG.FILTERS.CLIENT_COMPANY_TYPE');
        const ClientTypeSegmentMarket = environment.get('CONFIG.FILTERS.CLIENT_TYPE_SEGMENT_MARKET');
        const SocialCapitalType = environment.get('CONFIG.FILTERS.SOCIAL_CAPITAL_TYPES');

        const commercialRelationshipTypesSource = [
            {
                name: 'commercial_relationship_types',
                position: 1,
                data: CommercialRelationshipTypes,
                fields: [
                    {
                        title: translate('Common.CommercialRelationship'),
                        name: 'clientCompanyType',
                        value: 'id',
                        text: 'name',
                        type: 'multiselect',
                        orderBy: "name"
                    },
                ]
            }
        ];

        const clientTypeSegmentMarket = [
            {
                name: 'client_segment_market',
                position: 3,
                data: ClientTypeSegmentMarket,
                fields: [
                    {
                        title: translate('Common.TypeSegmentMarket'),
                        name: 'typeSegmentMarket',
                        value: 'id',
                        text: 'description',
                        type: 'multiselect',
                        orderBy: 'description'
                    }
                ]
            }
        ];

        const socialCapitalType = [
            {
                name: 'social_capital_type',
                position: 4,
                data: SocialCapitalType,
                fields: [
                    {
                        title: translate('Common.SocialCapital'),
                        name: 'socialCapitalType',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        orderBy: 'nome'
                    }
                ]
            }
        ];

        let data = [...commercialRelationshipTypesSource, ...clientTypeSegmentMarket, ...socialCapitalType];

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/companyCustomersPotentialAfterSales.factory.js